"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("./app");
require("./index.css");
if (module.hot) {
    module.hot.accept("./app", function () {
        var loader = require("./app").loader;
        loader();
    });
    module.hot.accept("./index.css", function () { return require("./index.css"); });
}
app_1.loader();
